import * as Yup from "yup";
import { i18n } from "us.helper";
import { DataToken, DataTokenType } from "interfaces";
import { isNumeric } from "components/TemplateEditor/Functions";

const ValidationSchema = (tokens: any[]) => {
  return Yup.object<any>().shape({
    rules: Yup.array().of(
      Yup.object().shape({
        isDeleted: Yup.boolean(),
        conditions: Yup.array().when("isDeleted", {
          is: true,
          then: Yup.array(),
          otherwise: Yup.array().of(
            Yup.object().shape({
              leftOperand: Yup.string()
                .nullable()
                .required(
                  "US.USC.TEMPLATEEDITOR:VALIDATIONS.LEFT_OPERAND_IS_REQUIRED"
                ),
              operator: Yup.string()
                .nullable()
                .required(
                  "US.USC.TEMPLATEEDITOR:VALIDATIONS.OPERATOR_IS_REQUIRED"
                ),
              rightOperand: Yup.string()
                .nullable()
                .test("last-condition", "", function (this: any, value: any) {
                  const leftOperand = this.parent?.leftOperand;
                  const leftOperandToken: DataToken = tokens.find(
                    (token: DataToken) => token.tokenValue === leftOperand
                  );
                  const leftOperandType = leftOperandToken?.tokenType;

                  const rightOperandToken: DataToken = tokens.find(
                    (token: DataToken) => token.tokenValue === value
                  );

                  let isValidDataType = true;

                  if (rightOperandToken) {
                    const rightOperandType = rightOperandToken.tokenType;
                    isValidDataType = leftOperandType === rightOperandType;
                  } else {
                    if (
                      leftOperandType === DataTokenType.DECIMAL ||
                      leftOperandType === DataTokenType.INT ||
                      leftOperand === "ActivityCode"
                    ) {
                      isValidDataType = isNumeric(value);
                      if (!isValidDataType) {
                        return this.createError({
                          message: `${i18n.t(
                            "US.USC.TEMPLATEEDITOR:VALIDATIONS.THE_VALUE_SHOULD_BE_A_NUMBER"
                          )}`,
                          path: this.path,
                        });
                      }
                    } else {
                      isValidDataType = typeof value === "string";
                      if (!isValidDataType) {
                        return this.createError({
                          message: `${i18n.t(
                            "US.USC.TEMPLATEEDITOR:VALIDATIONS.THE_VALUE_SHOULD_BE_A_STRING"
                          )}`,
                          path: this.path,
                        });
                      }
                    }
                  }
                  if (!isValidDataType) {
                    return this.createError({
                      message: `${i18n.t(
                        "US.USC.TEMPLATEEDITOR:VALIDATIONS.INVALID_DATA_TYPE"
                      )}`,
                      path: this.path,
                    });
                  }
                  return true;
                }),
              conjunction: Yup.string()
                .nullable()
                .test("last-condition", "", function (this: any, value: any) {
                  const { conditions } = this?.from[1]?.value ?? [];

                  if (
                    this.options?.index !== conditions?.length - 1 &&
                    !value
                  ) {
                    return this.createError({
                      message: `${i18n.t(
                        "US.USC.TEMPLATEEDITOR:VALIDATIONS.CONJUNCTION_IS_REQUIRED"
                      )}`,
                      path: this.path,
                    });
                  } else {
                    return true;
                  }
                }),
            })
          ),
        }),
      })
    ),
  });
};

export default ValidationSchema;
